import ApiController, { ApiRequest } from "../controller";

class MarketingModule extends ApiController {
  resource = "/marketing";

  massEmailUnsubscribe(email, code, guid) {
    const data = {
      email,
      code,
      guid
    }
    
    const request = new ApiRequest({
      method: "POST",
      url: `/massEmailUnsubscribe`,
      body: data
    });

    return this.request<any>(request);
  }
}

export default MarketingModule;

